export default __webpack_public_path__ + "static/media/image012.5b431cbe.png";